import { render, staticRenderFns } from "./TeacherDashboardContainer.vue?vue&type=template&id=17695616&scoped=true&"
import script from "./TeacherDashboardContainer.vue?vue&type=script&lang=js&"
export * from "./TeacherDashboardContainer.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDashboardContainer.vue?vue&type=style&index=0&id=17695616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17695616",
  null
  
)

export default component.exports